import React from "react";
import { useStore } from "../../store/store";
import { SelectChangeEvent } from "@mui/material";

function usePlacementSelection() {
  const addToQuote = useStore((state) => state.addToQuote);

  const comboUnitLeft = useStore((state) => state.quote.comboUnitLeft);
  const comboUnitRight = useStore((state) => state.quote.comboUnitRight);

  const handleSelectionLeft = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    const right = value === "Door" ? "Window" : "Door";
    addToQuote({
      comboUnitLeft: value,
      comboUnitRight: right,
      exactConfig: "",
      comboWindowConfig: "",
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
      screenType: "",
    });
  };

  const handleSelectionRight = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    const left = value === "Door" ? "Window" : "Door";
    addToQuote({
      comboUnitRight: value,
      comboUnitLeft: left,
      exactConfig: "",
      comboWindowConfig: "",
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
      screenType: "",
    });
  };

  return {
    handleSelectionLeft,
    handleSelectionRight,
    comboUnitLeft,
    comboUnitRight,
  };
}

export default usePlacementSelection;
